import { Image } from "primereact/image";
import img1 from "../../../assets/images/temp1.svg";
import { useEffect, useState, useRef } from "react";
import AtkLoader from "../../../AtlaskitControls/AtkLoader";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import Base64Image from "./Base64Image";

export default function ProposalCover(props: any) {
  const [isPreparedForEditing, setIsPreparedForEditing] = useState(false);
  const [isTitleEditing, setIsTitleEditing] = useState(false);
  const [preparedFor, setPreparedFor] = useState("");
  const [isPreparedByEditing, setIsPreparedByEditing] = useState(false);
  const [preparedBy, setPreparedBy] = useState("");
  const [title, setTitle] = useState(props.title || "");
  const normalizedTitle = (props.title ?? "").replace(/\s+/g, " ").trim();
  const [firstWord, ...restWords] = normalizedTitle.split(" ");
  const [year, setYear] = useState<string>("");
  // const year = props.proposalYear ? new Date(props.proposalYear).getFullYear().toString() : "";
  const [isWebsiteEditing, setIsWebsiteEditing] = useState(false);

  useEffect(() => {
    setPreparedBy(props.preparedBy);
    setPreparedFor(props.preparedFor);
    setTitle(props.title);
    setYear(new Date(props.proposalYear).getFullYear().toString());
  }, [props.preparedBy, props.preparedFor, props.title, props.proposalYear]);

  return (
    <div className="container p-0 text-light border mt-2">
      <div className="  w-100" style={{}}>
        <div className="row g-0 mx-auto">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12 px-4 d-flex justify-content-lg-between justify-content-center align-items-center bg-white text-center text-md-start">
            {/* <Image src={props.logoURL} alt="Insurance Image" className="rounded mt-1" height="80px" /> */}
            <Base64Image imageUrl={props.logoURL || ""} className="rounded mt-1" alt="Insurance Image" height="80px" />
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 col-12 p-1 d-flex flex-column flex-md-row justify-content-md-end align-items-center text-muted small text-center text-md-end">
            {isWebsiteEditing ? (
              <InputText value={props.website} onChange={props.onWebsiteUrlChange} className="text-12 w-100 w-md-auto mt-1" />
            ) : (
              <span>{props.website}</span>
            )}
            {props.isEditable && !props.isGeneratingPdf && (
              <>
                {!isWebsiteEditing ? (
                  <i className="fa fa-pencil text-12 ms-md-2 mt-1 show-cursor" title="Edit" onClick={() => setIsWebsiteEditing(true)} />
                ) : (
                  <span className="text-12 d-flex justify-content-center justify-content-md-end align-items-center mt-1">
                    {isWebsiteEditing && props.saveLoading ? (
                      <div className="d-inline-flex align-items-center">
                        <AtkLoader />
                      </div>
                    ) : (
                      <i
                        className="fa fa-check mx-2 show-cursor text-success"
                        title="Save"
                        onClick={() => {
                          setIsWebsiteEditing(false);
                          props.onTemplateDetailsSave();
                        }}
                      />
                    )}
                    <i
                      className="fa fa-times show-cursor text-danger"
                      title="Cancel"
                      onClick={() => {
                        setIsWebsiteEditing(false);
                        props.onCancelTemplateDetailsToSave();
                      }}
                    />
                  </span>
                )}
              </>
            )}
          </div>

          <div className="col-12 position-relative d-flex justify-content-between px-4 py-3 bg-white " style={{ height: "275px" }}>
            <div className="position-absolute d-inline-block z-1" style={{ bottom: "-45%", border: "1px solid #fff" }}>
              <Base64Image imageUrl={props.templateImages?.split(",")[0] || ""} className="rounded " alt="Insurance Image" height="330px"/>

              <div
                className="position-absolute  "
                style={{ width: "135px", height: "14px", top: "-20px", right: "-20px", backgroundColor: `${props.secondaryColor}` }}
              ></div>
              <div
                className="position-absolute   "
                style={{ width: "14px", height: "135px", right: "-20px", top: "-10px", backgroundColor: `${props.secondaryColor}` }}
              ></div>
            </div>
          </div>
        </div>
        <div className="row mx-auto ms-2" style={{ backgroundColor: `${props.primaryColor}`, color: "#fff" }}>
          <div className="position-relative col-6 d-flex flex-wrap py-4" style={{ backgroundColor: `${props.primaryColor}` }}>
            <div className=" text-center mb-3 mb-md-0"></div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 proposal-cover-title">
            <div className="">
              {isTitleEditing ? (
                <div className="d-flex align-items-start my-2">
                  <InputTextarea
                    value={title}
                    onChange={props.onTitleChange}
                    autoResize
                    className="text-12 flex-grow-1" // textarea fills available width
                  />

                  {props.isEditable && !props.isGeneratingPdf && (
                    <div className="ms-2 d-flex align-items-center">
                      {props.saveLoading ? (
                        <AtkLoader />
                      ) : (
                        <>
                          <i
                            className="fa fa-check mx-1 show-cursor text-success"
                            onClick={() => {
                              setIsTitleEditing(false);
                              props.onTemplateDetailsSave();
                            }}
                            title="Save"
                          />
                          <i
                            className="fa fa-times mx-1 show-cursor text-danger"
                            onClick={() => {
                              setIsTitleEditing(false);
                              props.onCancelTemplateDetailsToSave();
                            }}
                            title="Cancel"
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div className="">
                  <h2 className="fw-normal mb-1 position-relative d-inline-block">
                    {firstWord}{" "}
                    {props.isEditable && !props.isGeneratingPdf && (
                      <div style={{ position: "absolute", top: "-5px", right: "-30px" }}>
                        <i className="fa fa-pencil text-12 show-cursor" title="Edit" onClick={() => setIsTitleEditing(true)} />
                      </div>
                    )}
                  </h2>
                  <h1 className="fw-bold mb-2">{restWords.join(" ")}</h1>
                </div>
              )}
            </div>

            <div className="text-white d-inline-block  small">
              <span className=" ps-3 pe-5 py-1  small" style={{ backgroundColor: `${props.secondaryColor}` }}>
                {new Date().getFullYear()}
              </span>
            </div>
          </div>

          <div className="col-12 d-flex flex-column align-items-center py-5" style={{ backgroundColor: `${props.primaryColor}`, marginTop: "1rem" }}>
            <div className="row w-100 mx-auto">
              <div className="responsive-border col-lg-6 col-md-6 col-sm-12 mb-4  me-4">
                <div className="d-flex align-items-center ">
                  <h6 className="fw-bold text-white">
                    Prepared for:{" "}
                    {props.isEditable && !props.isGeneratingPdf ? (
                      <>
                        {!isPreparedForEditing ? (
                          <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsPreparedForEditing(true)} />
                        ) : (
                          <span className="text-12 ">
                            {isPreparedForEditing && props.saveLoading ? (
                              <div className="d-inline-flex align-items-center">
                                <AtkLoader />
                              </div>
                            ) : (
                              <i
                                className="fa fa-check mx-2 show-cursor text-success"
                                onClick={() => {
                                  setIsPreparedForEditing(false);
                                  props.onTemplateDetailsSave();
                                }}
                                title="Save"
                              />
                            )}
                            <i
                              className="fa fa-times show-cursor text-danger"
                              title="Cancel"
                              onClick={() => {
                                setIsPreparedForEditing(false);
                                props.onCancelTemplateDetailsToSave();
                              }}
                            />
                          </span>
                        )}
                      </>
                    ) : null}
                  </h6>
                </div>
                {isPreparedForEditing ? (
                  <InputTextarea value={preparedFor} onChange={props.onPreparedForChange} autoResize className="text-12 w-100 mt-1" />
                ) : (
                  <p className="mb-1 text-white opacity-75 text-14">{preparedFor}</p>
                )}
              </div>
              <div className="col mb-4 ">
                <h6 className="fw-bold text-white">
                  Prepared by:{" "}
                  {props.isEditable && !props.isGeneratingPdf ? (
                    <>
                      {!isPreparedByEditing ? (
                        <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsPreparedByEditing(true)} />
                      ) : (
                        <span className="text-12 ">
                          {isPreparedByEditing && props.saveLoading ? (
                            <div className="d-inline-flex align-items-center">
                              <AtkLoader />
                            </div>
                          ) : (
                            <i
                              className="fa fa-check mx-2 show-cursor text-success"
                              onClick={() => {
                                setIsPreparedByEditing(false);
                                props.onTemplateDetailsSave();
                              }}
                              title="Save"
                            />
                          )}
                          <i
                            className="fa fa-times show-cursor text-danger"
                            title="Cancel"
                            onClick={() => {
                              setIsPreparedByEditing(false);
                              props.onCancelTemplateDetailsToSave();
                            }}
                          />
                        </span>
                      )}
                    </>
                  ) : null}
                </h6>
                {isPreparedByEditing ? (
                  <div className="">
                    <InputTextarea value={preparedBy} onChange={props.onPreparedByChange} autoResize className="text-12 w-100 mt-1" />
                  </div>
                ) : (
                  <span className="text-white opacity-75 text-14">
                    <p className="mb-1">{preparedBy}</p>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="position-relative text-center text-light small mt-3 border-top p-4 w-100"
          style={{ backgroundColor: `${props.primaryColor}`, color: "#fff" }}
        >
          <div
            className="position-absolute  "
            style={{ width: "70%", height: "14px", top: "0px", left: "15%", backgroundColor: `${props.secondaryColor}` }}
          ></div>
        </div>
      </div>
    </div>
  );
}